<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="6">
        <b-form onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              v-model="form.keyword"
              @keyup.enter="clickQuery"
              type="search"
              :placeholder="
                $l('form_placeholder_fabric_name_search') || '面料名称搜索...'
              "
              size="sm"
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="visible = !visible"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="clickQuery">
                    <i class="fa fa-search"></i>
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <el-badge :value="checkedCount" class="ml-2">
              <b-button
                :disabled="checkedCount < 1"
                size="sm"
                class="ml-2"
                variant="outline-success"
                @click="openCart"
              >
                {{ '购物车' }}
              </b-button>
            </el-badge>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="visible"
      width="1000px"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="form" label-width="130px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$l('form_label_fabric_name') || '面料名称'">
              <dict-select
                v-model="form.fabricDescriptionArray"
                url="/digitalCenter/master/fabric/attributes/attributesSelect"
                :body="{ fabricAttrTypeEn: 'Fabric Description' }"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                clearable
                filterable
                multiple
                :options="{ label: 'label', value: 'this' }"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_pattern') || '花型'">
              <dict-select
                v-model="form.patternArray"
                url="/digitalCenter/master/fabric/attributes/attributesSelect"
                :body="{ fabricAttrTypeEn: 'Pattern' }"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                clearable
                filterable
                multiple
                :options="{ label: 'label', value: 'this' }"
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12"
            ><el-form-item :label="$l('table_label_techName') || '工艺'">
              <dict-select
                v-model="form.techniqueArray"
                url="/digitalCenter/master/fabric/attributes/attributesSelect"
                :body="{ fabricAttrTypeEn: 'Technique' }"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                clearable
                filterable
                multiple
                :options="{ label: 'label', value: 'this' }"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('INDEX.choose_fabric_function') || '功能'">
              <dict-select
                v-model="form.functionArray"
                url="/digitalCenter/master/fabric/attributes/attributesSelect"
                :body="{ fabricAttrTypeEn: 'Function' }"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                clearable
                filterable
                multiple
                :options="{ label: 'label', value: 'this' }"
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-row :gutter="10">
              <el-form-item :label="$l('form_label_fabric_weight') || '克重'">
                <el-col :span="16">
                  <el-row>
                    <el-col :span="11">
                      <el-input-number
                        controls-position="right"
                        style="width: 100%"
                        size="small"
                        :min="0"
                        :step="0.01"
                        :precision="2"
                        :placeholder="
                          $l('INDEX.tips_input_placeholder') || '请输入...'
                        "
                        v-model="form.fabricWeightStart"
                      ></el-input-number>
                    </el-col>
                    <el-col class="line" :span="2">-</el-col>
                    <el-col :span="11">
                      <el-input-number
                        controls-position="right"
                        style="width: 100%"
                        size="small"
                        :min="0"
                        :step="0.01"
                        :precision="2"
                        :placeholder="
                          $l('INDEX.tips_input_placeholder') || '请输入...'
                        "
                        v-model="form.fabricWeightEnd"
                      ></el-input-number>
                    </el-col>
                  </el-row>
                </el-col>
                <el-col :span="8">
                  <dict-select
                    v-model="form.fabricWeightUnit"
                    url="/digitalCenter/common/dict/biz"
                    :body="{ dictType: 'fabricWeightUnit' }"
                    :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                    size="small"
                    filterable
                    clearable
                  ></dict-select>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row :gutter="10">
              <el-form-item :label="$l('form_label_fabric_wid') || '门幅'">
                <el-col :span="18">
                  <el-row>
                    <el-col :span="11">
                      <el-input-number
                        controls-position="right"
                        style="width: 100%"
                        size="small"
                        :min="0"
                        :step="0.01"
                        :precision="2"
                        :placeholder="
                          $l('INDEX.tips_input_placeholder') || '请输入...'
                        "
                        v-model="form.fabricWidStart"
                      ></el-input-number>
                    </el-col>
                    <el-col class="line" :span="2">-</el-col>
                    <el-col :span="11">
                      <el-input-number
                        controls-position="right"
                        style="width: 100%"
                        size="small"
                        :min="0"
                        :step="0.01"
                        :precision="2"
                        :placeholder="
                          $l('INDEX.tips_input_placeholder') || '请输入...'
                        "
                        v-model="form.fabricWidEnd"
                      ></el-input-number>
                    </el-col>
                  </el-row>
                </el-col>
                <el-col :span="6">
                  <dict-select
                    v-model="form.widUnit"
                    url="/digitalCenter/common/dict/biz"
                    :body="{ dictType: 'widUnit' }"
                    :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                    size="small"
                    filterable
                    clearable
                  ></dict-select>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12"
            ><el-form-item :label="$l('form_label_fabric_content') || '成分'">
              <el-input
                v-model="form.fabricContent"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
                maxlength="200"
                size="small"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-row :gutter="10">
              <el-form-item :label="$l('form_label_unitPrice') || '面料单价'">
                <el-col :span="18">
                  <el-row>
                    <el-col :span="11">
                      <el-input-number
                        controls-position="right"
                        style="width: 100%"
                        size="small"
                        :min="0"
                        :step="0.01"
                        :precision="2"
                        :placeholder="
                          $l('INDEX.tips_input_placeholder') || '请输入...'
                        "
                        v-model="form.unitPriceStart"
                      ></el-input-number>
                    </el-col>
                    <el-col class="line" :span="2">-</el-col>
                    <el-col :span="11">
                      <el-input-number
                        controls-position="right"
                        style="width: 100%"
                        size="small"
                        :min="0"
                        :step="0.01"
                        :precision="2"
                        :placeholder="
                          $l('INDEX.tips_input_placeholder') || '请输入...'
                        "
                        v-model="form.unitPriceEnd"
                      ></el-input-number>
                    </el-col>
                  </el-row>
                </el-col>
                <el-col :span="6">
                  <dict-select
                    v-model="form.fabricUnit"
                    url="/digitalCenter/common/dict/biz"
                    :body="{ dictType: 'fabricYarnUnit' }"
                    :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                    size="small"
                    filterable
                    clearable
                  ></dict-select>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_scmName') || '供应商'"
              prop="resScmCode"
            >
              <dict-select
                size="small"
                clearable
                filterable
                v-model="form.resScmCode"
                url="/master/common/dict/allScmCooperated"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_fty_no') || '厂家编号'">
              <el-input
                v-model="form.ftyNo"
                :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
                maxlength="200"
                size="small"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <el-row :gutter="10">
              <el-form-item :label="$l('form_label_resDate') || '调研日期'">
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.resDateStart"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.resDateEnd"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row :gutter="10">
              <el-form-item :label="$l('form_label_publishDate') || '发布日期'">
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.publishDateStart"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.publishDateEnd"
                    type="date"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">{{
          $l('INDEX.btn_cancel_query') || '取消查询'
        }}</el-button>
        <el-button size="small" type="warning" @click="onReset">{{
          $l('INDEX.btn_reset_filter ') || '重置条件'
        }}</el-button>
        <el-button size="small" type="primary" @click="clickQuery">{{
          $l('INDEX.btn_data_retrieval') || '数据检索'
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    checkedCount: {type: Number, default: 0}
  },
  data() {
    return {
      visible: false,
      provinceOptions: [], //  省份
      cityOptions: [], //  市
      districtOptions: [], //  县
      categoryOptions: [], // 供应商类别下拉
      factoryInspectionOptions: [], //工厂资质
      certificateInfoOptions: [], //证书类型
      suitableForCustomersOptions: [], //适用客户
      form: {
        keyword: '',
        fabricDescriptionArray: [],
        patternArray: [],
        techniqueArray: [],
        functionArray: [],
      },
    }
  },

  methods: {
  
    closeDialog() {
      this.visible = false
    },
    clickQuery() {
      this.$emit('reset')
      this.query()
    },
    openCart() {
      this.$emit('openCart')
    },

    onReset() {
      this.form = {
        keyword: '',
      }
      this.$emit('reset')
      this.query()
    },
    query() {
      this.$emit('submit', this.form)
      this.visible = false
    },
    reset() {
      this.query()
    },
  },
  mounted() {
    this.onReset()
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
